import type { ReadonlyRequestCookies } from 'next/dist/server/web/spec-extension/adapters/request-cookies';

export const UTM_KEYS = [
	'utm_source',
	'utm_medium',
	'utm_campaign',
	'utm_term',
	'utm_content',
] as const;

const UTM_QUERY_ALIASES: Record<(typeof UTM_KEYS)[number], string[]> = {
	utm_source: ['utm_source', 'utmSource'],
	utm_medium: ['utm_medium', 'utmMedium'],
	utm_campaign: ['utm_campaign', 'utmCampaign'],
	utm_term: ['utm_term', 'utmTerm'],
	utm_content: ['utm_content', 'utmContent'],
};

export const UTM_COOKIE_NAME = 'utm_data';
export const UTM_COOKIE_TTL = 60 * 60 * 24 * 30; // 30 дней

export const getUtmCookieOptions = () => ({
	path: '/' as const,
	days: UTM_COOKIE_TTL / (60 * 60 * 24),
});

export type UtmCookies = Record<string, string>;

export const utmFromUrl = (searchParams: URLSearchParams) => {
	const utm: UtmCookies = {};

	for (const key of UTM_KEYS) {
		const value = UTM_QUERY_ALIASES[key]
			.map((alias) => searchParams.get(alias))
			.find((candidate) => Boolean(candidate));
		if (value) {
			utm[key] = value;
		}
	}

	return Object.keys(utm).length > 0 ? utm : null;
};

export const utmFromCookie = (
	cookieStore: ReadonlyRequestCookies,
): UtmCookies | null => {
	const cookie = cookieStore.get(UTM_COOKIE_NAME);

	if (!cookie) {
		return null;
	}

	return JSON.parse(cookie.value);
};
